import React, { Component } from "react";
import { TextField, Button, CircleProgress } from "reactackle";
import { isMobile } from "react-device-detect";
import PhotoUploadPass from "../FieldsComponents/PhotoUpload/PhotoUploadPass";

class SendRemittance extends Component {
  state = {
    data: {
      path: "",
      payload: {
        beneficiaryName: "",
        beneficiaryAddress: "",
        toCcy: "",
        selectedExchange: ""
      }
    },
    selectedExchange: "",
    stage: "input"
  };

  componentDidMount() {
    //this.stateChangeHandler(true, "rateLoader", false);
    if (
      this.props.myRemitApplication &&
      Object.keys(this.props.myRemitApplication).length > 0
    ) {
      this.setState(this.props.myRemitApplication);
    }
  }
  componentWillUnmount() {
    this.props.onAddRecord({
      path: "myRemitApplication",
      payload: this.state
    });
  }

  //single method that work for all fields
  //takes incoming id of the field and then adds field data to state
  stateChangeHandler = (val, id, isPayload, postAction) => {
    // console.log(
    //   "val: " + JSON.stringify(val) + " id: " + id + " isPayload: " + isPayload
    // );
    let tmpState = {};
    tmpState[id] = val;

    if (isPayload) {
      this.setState(
        prevState => {
          if (prevState && prevState.data.payload !== null) {
            return {
              ...prevState,
              data: {
                ...prevState.data,
                payload: {
                  ...prevState.data.payload,
                  ...tmpState
                }
              }
            };
          } else {
            return {
              ...prevState,
              data: {
                path: prevState.data.path,
                payload: {
                  ...tmpState
                }
              }
            };
          }
        },
        postAction !== undefined && postAction !== null ? postAction : null
      );
    } else {
      this.setState(
        prevState => {
          return {
            ...prevState,
            ...tmpState
          };
        },
        postAction !== undefined && postAction !== null ? postAction : null
      );
    }
  };

  getExchanges = () => {
    let avlblExcgs = this.props.myRemitRegs.filter(
      exch => exch.status === "ACTIVE"
    );
    if (avlblExcgs && avlblExcgs.length > 0) {
      return avlblExcgs.map(exch => {
        return (
          <div style={{ textAlign: "center", padding: "5px" }}>
            <div
              style={{
                width: "80%",
                padding: "1px",
                textAlign: "center",
                border: "1px solid gainsboro",
                borderRadius: isMobile ? "5px" : "0px",
                backgroundColor:
                  this.state.data.payload.selectedExchange === exch.exchange
                    ? "rgb(30, 101, 144)"
                    : "gainsboro",
                margin: "auto",
                padding: "6px",
                fontWeight: "bold",
                color:
                  this.state.data.payload.selectedExchange === exch.exchange
                    ? "white"
                    : "black",
                fontSize: "12px",
                minWidth: "140px"
              }}
              onClick={() => {
                this.stateChangeHandler(
                  exch.exchange,
                  "selectedExchange",
                  true,
                  null
                );
                this.stateChangeHandler(exch, "customer", true, null);
                this.calcAmount("SGD");
              }}
            >
              <div>{exch.exchange.replace("Pte Ltd", "")}</div>
            </div>
          </div>
        );
      });
    }
  };

  getExchangeSelector = () => {
    return (
      <div
        style={{
          padding: "5px",
          border: "1px solid gainsboro",
          borderRadius: "5px",
          marginBottom: "10px"
        }}
      >
        {(!this.state.data.payload.selectedExchange ||
          this.state.data.payload.selectedExchange === "") && (
          <div>Select Exchange Company</div>
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-evenly"
          }}
        >
          {this.getExchanges()}
        </div>
        {this.state.data.payload.selectedExchange &&
          this.state.data.payload.selectedExchange != "" &&
          this.getRates()}
      </div>
    );
  };

  getLoader = () => {
    return (
      <div
        style={{
          textAlign: "center",
          paddingTop: "10px"
        }}
      >
        <CircleProgress
          indeterminate
          subtitle="Loading rates..."
          circleSize={20}
          strokeSize={2}
          labelPositionY="bottom"
          labelPositionX="center"
        />
      </div>
    );
  };

  genRateTable = rateArray => {
    if (rateArray && rateArray.length > 0) {
      return rateArray.map(obj => {
        return (
          <td
            style={{
              minWidth: "70px",
              textAlign: "center",
              padding: "1px",
              lineHeight: "32px"
            }}
          >
            {" " + obj.rate + "  " + obj.toCcy}
          </td>
        );
      });
    }
  };

  getRates = () => {
    let rates = {};
    if (
      this.state.data.payload.selectedExchange &&
      this.state.data.payload.selectedExchange.includes("Agrani")
    ) {
      rates = this.props.agraniRates;
    }
    if (
      this.state.data.payload.selectedExchange &&
      this.state.data.payload.selectedExchange.includes("Prime")
    ) {
      rates = this.props.primeRates;
    }

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center"
        }}
      >
        {rates && rates !== undefined && (
          <div
            style={{
              fontSize: "12px"
            }}
          >
            <table
              className="table table-bordered"
              style={{ marginBottom: "0px" }}
            >
              <tbody>
                <tr>
                  <td
                    style={{
                      textAlign: "right",
                      minWidth: "70px"
                    }}
                  >
                    1 SGD ={" "}
                  </td>
                  {this.genRateTable(rates.result)}
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  getRemitForm = () => {
    return (
      <div>
        <div>Some user help text</div>
        <div>Video link?</div>
      </div>
    );
  };

  getFlag = toCcyCode => {
    if (toCcyCode === "BDT") {
      return (
        <img
          style={{
            height: "32px",
            width: "32px"
          }}
          src="data:image/png;base64,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"
        />
      );
    }
    if (toCcyCode === "INR") {
      return (
        <img
          style={{
            height: "32px",
            width: "32px"
          }}
          src="data:image/png;base64,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"
        />
      );
    }
  };

  getCurrencyButton = toCcyCode => {
    return (
      <div
        style={{
          padding: "1px",
          paddingLeft: "5px",
          paddingRight: "5px",
          textAlign: "center",
          border: "1px solid gainsboro",
          borderRadius: isMobile ? "5px" : "0px",
          backgroundColor:
            this.state.data.payload.toCcy === toCcyCode
              ? "rgb(30, 101, 144)"
              : "gainsboro",
          marginLeft: "2px",
          marginRight: "2px",

          fontWeight: "bold",
          color: this.state.data.payload.toCcy === toCcyCode ? "white" : "black"
        }}
        onClick={() => {
          this.stateChangeHandler(toCcyCode, "toCcy", true, () =>
            this.calcAmount("SGD")
          );
        }}
      >
        <span
          style={{
            marginLeft: "3px",
            marginRight: "5px"
          }}
        >
          {this.getFlag(toCcyCode)}
        </span>
        {toCcyCode}
      </div>
    );
  };

  getAmountsBlock = () => {
    return (
      <div
        style={{
          padding: "5px",
          border: "1px solid gainsboro",
          borderRadius: "5px",
          marginBottom: "10px"
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            padding: "2px"
          }}
        >
          <div
            style={{
              width: "30%",
              lineHeight: "48px"
            }}
          >
            To Currency
          </div>

          <div
            style={{
              width: "70%",
              border: "1px solid gainsboro",
              borderRadius: "5px",
              borderTopLeftRadius: "0px",
              borderBottomLeftRadius: "0px",
              margin: "2px"
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-evenly",
                lineHeight: "24px",
                margin: "5px"
              }}
            >
              {this.getCurrencyButton("BDT")} {this.getCurrencyButton("INR")}
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            padding: "2px"
          }}
        >
          <div
            style={{
              width: "30%",
              lineHeight: "48px"
            }}
          >
            SGD Amount
          </div>

          <div
            style={{
              width: "70%",
              border: "1px solid gainsboro",
              borderRadius: "5px",
              borderTopLeftRadius: "0px",
              borderBottomLeftRadius: "0px",
              margin: "2px"
            }}
          >
            <TextField
              value={this.state.data.payload["sgdAmount"]}
              onChange={e => {
                this.stateChangeHandler(e.value, "sgdAmount", true, () => {
                  this.calcAmount("SGD");
                });
              }}
              fullWidth
              placeholder={""}
            />
          </div>
        </div>
        {this.state.data.payload.toCcy && this.state.data.payload.toCcy !== "" && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              padding: "2px"
            }}
          >
            <div
              style={{
                width: "30%",
                lineHeight: "48px"
              }}
            >
              {this.state.data.payload.toCcy} Amount
            </div>

            <div
              style={{
                width: "70%",
                border: "1px solid gainsboro",
                borderRadius: "5px",
                borderTopLeftRadius: "0px",
                borderBottomLeftRadius: "0px",
                margin: "2px"
              }}
            >
              <TextField
                value={this.state.data.payload["destAmount"]}
                onChange={e => {
                  this.stateChangeHandler(e.value, "destAmount", true, () => {
                    this.calcAmount("destAmount");
                  });
                }}
                fullWidth
                placeholder={""}
              />
            </div>
          </div>
        )}
      </div>
    );
  };

  getPayeeInputField = (caption, fldName, multiline, numOfLines) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          padding: "2px"
        }}
      >
        <div
          style={{
            width: "30%",
            lineHeight: "48px"
          }}
        >
          {caption}
        </div>

        <div
          style={{
            width: "70%",
            border: "1px solid gainsboro",
            borderRadius: "5px",
            borderTopLeftRadius: "0px",
            borderBottomLeftRadius: "0px",
            margin: "2px",
            padding: "3px"
          }}
        >
          <TextField
            value={this.state.data.payload[fldName]}
            onChange={e => {
              this.stateChangeHandler(e.value, fldName, true);
            }}
            fullWidth
            placeholder={""}
            multiline={multiline}
            multilineRows={{ min: multiline ? numOfLines : 1 }}
          />
        </div>
      </div>
    );
  };

  getBeneficiaryBlock = () => {
    return (
      <div
        style={{
          padding: "5px",
          border: "1px solid gainsboro",
          borderRadius: "5px",
          marginBottom: "10px"
        }}
      >
        <div>Payee Info</div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            padding: "2px"
          }}
        >
          <div
            style={{
              width: "30%",
              lineHeight: "48px"
            }}
          >
            Send To
          </div>

          <div
            style={{
              width: "70%",
              border: "1px solid gainsboro",
              borderRadius: "5px",
              borderTopLeftRadius: "0px",
              borderBottomLeftRadius: "0px",
              margin: "2px",
              padding: "3px"
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                lineHeight: "20px",
                margin: "auto",
                overflow: "scroll"
              }}
            >
              {this.getPickUpTypes()}
            </div>
          </div>
        </div>

        {this.getPayeeInputField("Name", "payeeName")}
        {this.getPayeeInputField("Contact", "payeeContact")}
        {this.getPayeeInputField("Address", "payeeAddress", true, 3)}
        {this.getPayeeInputField("Relation", "payeeRelation")}
        {this.getPayeeInputField("Purpose", "remitPurpose", true, 3)}
        {this.state.data.payload.pickupType === "BANK ACCOUNT" &&
          this.getPayeeInputField("Account#", "payeeAccountNumber")}
        {this.state.data.payload.pickupType === "BANK ACCOUNT" &&
          this.getPayeeInputField("Account Name", "payeeAccountName", true, 3)}
        {this.state.data.payload.pickupType === "BANK ACCOUNT" &&
          this.getPayeeInputField("Bank Name", "payeeBankName", true, 3)}
        <div
          style={{
            padding: "5px",
            textAlign: "center",
            border: "1px solid gainsboro",
            borderRadius: isMobile ? "5px" : "0px",
            backgroundColor: "rgb(30, 101, 144)",
            margin: "2px",
            fontWeight: "bold",
            color: "white"
          }}
          onClick={() => {
            this.stateChangeHandler("photo", "stage", false);
            this.props.setScroll(true);
          }}
        >
          NEXT
        </div>
      </div>
    );
  };

  getPickUpTypes = () => {
    if (
      this.state.data.payload.selectedExchange &&
      this.state.data.payload.selectedExchange.includes("Agrani")
    ) {
      if (this.state.data.payload.toCcy === "BDT") {
        return this.getPickUpButtons(["BKASH", "CASH PICKUP", "BANK ACCOUNT"]);
      } else {
        return this.getPickUpButtons(["CASH PICKUP", "BANK ACCOUNT"]);
      }
    }

    if (
      this.state.data.payload.selectedExchange &&
      this.state.data.payload.selectedExchange.includes("Prime")
    ) {
      return this.getPickUpButtons(["CASH PICKUP", "BANK ACCOUNT"]);
    }
  };

  getPickUpButtons = btnArray => {
    //console.log(JSON.stringify(btnArray));
    if (btnArray && btnArray.length > 0) {
      return btnArray.map(pickupType => {
        return (
          <span
            style={{
              padding: "1px",
              paddingLeft: "5px",
              paddingRight: "5px",
              textAlign: "center",
              border: "1px solid gainsboro",
              borderRadius: isMobile ? "5px" : "0px",
              backgroundColor:
                this.state.data.payload.pickupType === pickupType
                  ? "rgb(30, 101, 144)"
                  : "gainsboro",
              margin: "2px",
              fontWeight: "bold",
              color:
                this.state.data.payload.pickupType === pickupType
                  ? "white"
                  : "black"
            }}
            onClick={() => {
              this.stateChangeHandler(pickupType, "pickupType", true);
            }}
          >
            {pickupType}
          </span>
        );
      });
    }
  };

  calcAmount = fromCcy => {
    //console.log("ra ra " + fromCcy);
    let rates = {};
    if (
      this.state.data.payload.selectedExchange &&
      this.state.data.payload.selectedExchange.includes("Agrani")
    ) {
      rates = this.props.agraniRates;
    }
    if (
      this.state.data.payload.selectedExchange &&
      this.state.data.payload.selectedExchange.includes("Prime")
    ) {
      rates = this.props.primeRates;
    }
    if (
      this.state.data.payload.toCcy &&
      this.state.data.payload.toCcy !== "" &&
      rates &&
      rates !== undefined &&
      rates.result &&
      rates.result.length > 0
    ) {
      if (fromCcy === "SGD") {
        if (
          this.state.data.payload.sgdAmount &&
          this.state.data.payload.sgdAmount !== ""
        ) {
          //   console.log(
          //     this.state.data.payload.sgdAmount +
          //       " : " +
          //       JSON.stringify(rates.result)
          //   );
          //   console.log(
          //     "calc something here: " +
          //       this.getTgtAmount(this.state.data.payload.sgdAmount) +
          //       "  :  " +
          //       this.getTgtRate(this.state.data.payload.toCcy, rates.result)
          //   );
          let srcAmount = this.getTgtAmount(this.state.data.payload.sgdAmount);
          let tgtRate = this.getTgtRate(
            this.state.data.payload.toCcy,
            rates.result
          );
          let tgtAmount = srcAmount * tgtRate;
          if (!isNaN(tgtAmount)) {
            this.stateChangeHandler(tgtAmount.toFixed(2), "destAmount", true);
            this.stateChangeHandler(tgtRate, "rate", true);
          } else {
            this.stateChangeHandler("", "destAmount", true);
          }
        }
      } else {
        let srcAmount = this.getTgtAmount(this.state.data.payload.destAmount);
        let tgtRate = this.getTgtRate(
          this.state.data.payload.toCcy,
          rates.result
        );
        let tgtAmount = srcAmount / tgtRate;
        if (!isNaN(tgtAmount)) {
          this.stateChangeHandler(tgtAmount.toFixed(2), "sgdAmount", true);
          this.stateChangeHandler(tgtRate, "tgtRate", true);
        } else {
          this.stateChangeHandler("", "sgdAmount", true);
        }
      }
    }
  };

  getTgtRate = (ccyCode, rates) => {
    if (rates && rates.length > 0) {
      let tgtRateObj = rates.find(rtObj => rtObj.toCcy === ccyCode);
      //   console.log(
      //     "ccyCode: " + ccyCode + " tgtRateObj: " + JSON.stringify(tgtRateObj)
      //   );
      if (
        tgtRateObj &&
        tgtRateObj !== undefined &&
        tgtRateObj.toCcy &&
        tgtRateObj.toCcy !== ""
      ) {
        return tgtRateObj.rate;
      } else {
        return 1;
      }
    } else {
      return 1;
    }
  };

  getTgtAmount = srcVal => {
    //console.log("getTgtAmount: " + srcVal);
    try {
      if (srcVal && srcVal !== "") {
        return srcVal;
      } else {
        return 0;
      }
    } catch (err) {
      return 0;
    }
  };

  getInputForm = () => {
    return (
      <div>
        <div>{this.getExchangeSelector()}</div>
        {this.state.data.payload.selectedExchange &&
          this.state.data.payload.selectedExchange !== "" && (
            <div>{this.getAmountsBlock()}</div>
          )}
        {this.state.data.payload.toCcy &&
          this.state.data.payload.toCcy !== "" && (
            <div>{this.getBeneficiaryBlock()}</div>
          )}
      </div>
    );
  };

  getNextBack = (stageBack, stageNext) => {
    return (
      <div>
        <table className="table">
          <tbody>
            <tr>
              <td style={{ border: "0px" }}>
                <div
                  style={{
                    textAlign: "center",
                    width: "100%"
                  }}
                >
                  <div
                    style={{
                      width: "50%",
                      padding: "1px",
                      textAlign: "center",
                      border: "1px solid gainsboro",
                      borderRadius: isMobile ? "5px" : "0px",
                      backgroundColor: "rgb(30, 101, 144)",
                      margin: "auto",
                      padding: "6px",
                      fontWeight: "bold",
                      color: "white",
                      fontSize: "12px",
                      minWidth: "140px"
                    }}
                    onClick={() => {
                      this.stateChangeHandler(stageBack, "stage", false);
                      this.props.setScroll(true);
                    }}
                  >
                    <div>
                      <i className="fa fa-arrow-left"></i> BACK
                    </div>
                  </div>
                </div>
              </td>
              <td style={{ border: "0px" }}>
                <div
                  style={{
                    textAlign: "center",
                    width: "100%"
                  }}
                >
                  <div
                    style={{
                      width: "50%",
                      padding: "1px",
                      textAlign: "center",
                      border: "1px solid gainsboro",
                      borderRadius: isMobile ? "5px" : "0px",
                      backgroundColor: "rgb(30, 101, 144)",
                      margin: "auto",
                      padding: "6px",
                      fontWeight: "bold",
                      color: "white",
                      fontSize: "12px",
                      minWidth: "140px"
                    }}
                    onClick={() => {
                      this.stateChangeHandler(stageNext, "stage", false);
                      this.props.setScroll(true);
                    }}
                  >
                    <div>
                      NEXT <i className="fa fa-arrow-right"></i>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  createRemitAppRec = () => {
    let cloudPath = "agraniApps/";
    let recObj = _.cloneDeep(this.state.data.payload);
    if (recObj.selectedExchange.includes("Prime")) {
      cloudPath = "primeApps/";
    }
    var passApp = this.props.firebase.db.ref("/" + cloudPath).push();
    passApp
      .set(recObj)
      .catch(err => {
        console.log("some error: " + err);
      })
      .then(err => {
        //clear the bucket
        this.props.firebase.db
          .ref(
            "/remSvc" + "/" + this.props.cellPhone + "/remApps/" + passApp.key
          )
          .once("value")
          .then(snap => {
            snap.ref.set(recObj);
          })
          .catch(err => {
            console.log("some error: " + err);
          })
          .then(err => {
            console.log("updated");
          });
      });
  };

  getEmailText = () => {
    let emTxt = "Dear Sir \n Please see below my application";
    emTxt = emTxt + " for sending remittance as per the following details: \n";
    emTxt = emTxt + "\n";
    emTxt = emTxt + "\n";
    emTxt =
      emTxt +
      "Sender Name: " +
      this.state.data.payload.customer.senderName +
      " \n";
    emTxt =
      emTxt +
      "Sender Address: " +
      this.state.data.payload.customer.senderAddress +
      " \n";
    emTxt =
      emTxt + "Id Type: " + this.state.data.payload.customer.idType + " \n";
    emTxt =
      emTxt + "ID #: " + this.state.data.payload.customer.idNumber + " \n";
    emTxt =
      emTxt + "Mobile: " + this.state.data.payload.customer.mobile + " \n";
    emTxt = tmTxt + "\n";
    emTxt = tmTxt + "\n";
    emTxt = tmTxt + "Payment Info: \n";
    emTxt = tmTxt + "\n";
    emTxt = tmTxt + "Payee Name: " + this.state.data.payload.payeeName;
    emTxt = tmTxt + "Payee Address: " + this.state.data.payload.payeeAddress;
    emTxt = tmTxt + "Payee Contact: " + this.state.data.payload.payeeContact;
    emTxt = tmTxt + "SGD Amount: " + this.state.data.payload.sgdAmount;
    emTxt = tmTxt + "Destination Currency: " + this.state.data.payload.toCcy;
    emTxt = tmTxt + "Destination Amount: " + this.state.data.payload.destAmount;
    emTxt = tmTxt + "Transfer Type: " + this.state.data.payload.pickupType;
    emTxt = tmTxt + "Transfer Type: " + this.state.data.payload.pickupType;

    emTxt =
      emTxt +
      "For any further information please rechout to me at my phone number provided above.\n";
    emTxt = emTxt + "\n";
    emTxt = emTxt + "\n Note: \n";
    emTxt = emTxt + "";
    emTxt = emTxt + "- This is a system generated email. \n";
    emTxt =
      emTxt +
      " - Information provided above is as per the data provided by users, and it is the responsibility of users to ensure correct input of all information. \n";
    emTxt =
      emTxt +
      "- For any further information please contact the applicant directly \n";
    emTxt = emTxt + "\n";
    emTxt = emTxt + "\n";
    return emTxt;
  };

  getHtmlRow = (heading, value) => {
    return (
      "<tr><td style='border: 1px solid black;padding: 5px'>" +
      heading +
      "</td><td style='border: 1px solid black;padding: 5px'>" +
      value +
      "</td></tr>"
    );
  };

  getEmailHtml = () => {
    let emTxt = "<p>Dear Sir </p><p> Please find below my application for ";
    emTxt = emTxt + " sending remittance as per the following details: </p>";
    emTxt = emTxt + "<p></p>";
    emTxt =
      emTxt +
      "<table style='border: 1px solid black;max-width: 450px;min-width:450px'><tbody>";
    emTxt =
      emTxt +
      this.getHtmlRow(
        "Sender Name",
        this.state.data.payload.customer.senderName
      );
    emTxt =
      emTxt +
      this.getHtmlRow(
        "Sender Address",
        this.state.data.payload.customer.senderAddress
      );
    emTxt + this.getHtmlRow("Id Type", this.state.data.payload.customer.idType);
    emTxt =
      emTxt +
      this.getHtmlRow("ID No.", this.state.data.payload.customer.idNumber);

    emTxt =
      emTxt +
      this.getHtmlRow("Mobile", this.state.data.payload.customer.mobile);
    emTxt =
      emTxt +
      this.getHtmlRow("Application Date", this.state.data.payload.appDate);

    emTxt = emTxt + this.getHtmlRow("", "");
    emTxt = emTxt + this.getHtmlRow("", "");
    emTxt = emTxt + this.getHtmlRow("Payment Info", "");
    emTxt =
      emTxt + this.getHtmlRow("Payee Name", this.state.data.payload.payeeName);
    emTxt =
      emTxt +
      this.getHtmlRow("Payee Address", this.state.data.payload.payeeAddress);
    emTxt =
      emTxt +
      this.getHtmlRow("Payee Contact", this.state.data.payload.payeeContact);
    emTxt =
      emTxt + this.getHtmlRow("SGD Amount", this.state.data.payload.sgdAmount);
    emTxt =
      emTxt +
      this.getHtmlRow("Destination Amount", this.state.data.payload.destAmount);
    emTxt =
      emTxt +
      this.getHtmlRow("Destination Currency", this.state.data.payload.toCcy);
    emTxt =
      emTxt +
      this.getHtmlRow("Transfer Type", this.state.data.payload.pickupType);

    emTxt = emTxt + "</tbody></table>";
    emTxt = emTxt + "<p></p><p></p>";

    emTxt =
      emTxt +
      "<p>For any further information please reachout to me at my phone number provided above. </p>";

    emTxt = emTxt + "<p>Notes:</p>";

    emTxt =
      emTxt +
      "<ul><li>Information provided in this application, is as per the data provided by users, and it is the responsibility of users to ensure correct input of all information.</li>";
    emTxt =
      emTxt +
      "<li>For any further information please contact the applicant directly</li></ul>";
    emTxt = emTxt + "</p>";
    emTxt = emTxt + "<p></p>";
    return emTxt;
  };

  submitRegistration = () => {
    let emailParams = {
      from: '"BCS Remittance Request" helper@brooklynzcommunitysupport.com', // sender address
      to: "ahmed_fayyaz@outlook.com", // list of receivers
      subject:
        "Remittance Request [ " +
        this.state.data.payload.senderName +
        " | " +
        this.state.data.payload.idNumber +
        " | " +
        this.props.cellPhone +
        " ]", // Subject line
      attachments: [],
      text: this.getEmailText(), // plain text body
      html: this.getEmailHtml() // html body
    };

    //get state updated with calc fields
    Promise.all([
      this.stateChangeHandler(true, "generatingStatement", false)
    ]).then(res => {
      //console.log("test test: " + res[1]);

      this.props
        .onSendEmail(emailParams)
        .then(emailResp => {
          //this.saveHandler();
          this.createRemitRegRec();
          //   let suppNotifyText =
          //     "New passport form generated by " +
          //     this.state.data.payload.textName +
          //     " (" +
          //     this.state.data.payload.phoneNumber +
          //     ").";
          //this.props.onNotifyUsers(suppNotifyText, ["94562455"]);
          this.stateChangeHandler(false, "generatingStatement", false);
          this.stateChangeHandler("genInput", "stage", false);

          //   this.props.onAddRecord({
          //     path: "myPassApplication",
          //     payload: {}
          //   });
        })
        .catch(err => {
          console.log("Salaaa error: " + err);
          this.stateChangeHandler(false, "generatingStatement", false);
        });
    });
    //request new statement
    //once req completed show the stop loader and show statement
  };

  getReview = () => {
    return (
      <div>
        <p
          style={{
            backgroundColor: "orange",
            padding: "5px",
            fontWeight: "bold"
          }}
        >
          Please carefully review the following information and press the
          confirm button (দয়াকরে নিচের তথ্যগুলো ভালকরে দেখে নিন, সবকিছু ঠিক
          থাকলে নিচের "কনফার্ম" বাটনে চাপুন।):
        </p>
        <div>
          <p>
            <b>Particulars</b>
          </p>
          <table className="table table-bordered table-striped">
            <tbody>
              {this.getRow("SGD Amount", this.state.data.payload.sgdAmount)}
              {this.getRow(
                this.state.data.payload.toCcy + " Amount",
                this.state.data.payload.destAmount
              )}
              {this.getRow("Rate", this.state.data.payload.rate)}
              {this.getRow("Currency", this.state.data.payload.toCcy)}
              {this.getRow("Payee Name", this.state.data.payload.payeeName)}
              {this.getRow(
                "Payee Contact",
                this.state.data.payload.payeeContact
              )}
              {this.getRow(
                "Payee Address",
                this.state.data.payload.payeeAddress
              )}
              {this.getRow(
                "Payee Relation",
                this.state.data.payload.payeeRelation
              )}
              {this.getRow("Purpose", this.state.data.payload.remitPurpose)}
              {this.getRow("Pickup Type", this.state.data.payload.pickupType)}
              {this.state.data.payload.pickupType === "BANK ACCOUNT" &&
                this.getRow(
                  "Acc Name",
                  this.state.data.payload.payeeAccountName
                )}
              {this.state.data.payload.pickupType === "BANK ACCOUNT" &&
                this.getRow("Acc#", this.state.data.payload.payeeAccountNumber)}
              {this.state.data.payload.pickupType === "BANK ACCOUNT" &&
                this.getRow("Bank Name", this.state.data.payload.payeeBankName)}
            </tbody>
          </table>
        </div>
        <p>
          <span>
            <div
              style={{
                textAlign: "center",
                width: "100%"
              }}
            >
              <div
                style={{
                  width: "50%",
                  padding: "1px",
                  textAlign: "center",
                  border: "1px solid gainsboro",
                  borderRadius: isMobile ? "5px" : "0px",
                  backgroundColor: "green",
                  margin: "auto",
                  padding: "6px",
                  fontWeight: "bold",
                  color: "white",
                  fontSize: "12px"
                }}
                onClick={() => {
                  alert("generate email here");
                }}
              >
                <div>
                  <i className="fa fa-check"></i> CONFIRM
                </div>
                <div>কনফার্ম</div>
              </div>
              {this.state.generatingStatement && this.getStatementLoader()}
            </div>
          </span>
          {!this.state.generatingStatement && (
            <span>
              <div
                style={{
                  textAlign: "center",
                  width: "100%"
                }}
              >
                <div
                  style={{
                    width: "50%",
                    padding: "1px",
                    textAlign: "center",
                    border: "1px solid gainsboro",
                    borderRadius: isMobile ? "5px" : "0px",
                    backgroundColor: "red",
                    margin: "auto",
                    padding: "6px",
                    fontWeight: "bold",
                    color: "white",
                    fontSize: "12px"
                  }}
                  onClick={() => {
                    this.stateChangeHandler("input", "stage", false);
                  }}
                >
                  <div>
                    <i className="fa fa-arrow-circle-left"></i> CHANGE
                  </div>
                  <div>পরিবর্তন করুন</div>
                </div>
              </div>
            </span>
          )}
        </p>
      </div>
    );
  };

  getPhotoInputForm = () => {
    return (
      <div>
        <div>
          <div
            style={{
              backgroundColor: "orange",
              padding: "5px",
              fontWeight: "bold",
              margin: "10px"
            }}
          >
            Please use internet banking to pay S$
            {this.state.data.payload.destAmount} fee as per the details provided
            below:
          </div>
          <div style={{ margin: "10px" }}>
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <td style={{ backgroundColor: "white" }}>Account Name</td>
                  <td style={{ backgroundColor: "white" }}>ACCOUNT NAME</td>
                </tr>
                <tr>
                  <td style={{ backgroundColor: "white" }}>Account Number</td>
                  <td style={{ backgroundColor: "white" }}>888-88-8888-88</td>
                </tr>
                <tr>
                  <td style={{ backgroundColor: "white" }}>Bank</td>
                  <td style={{ backgroundColor: "white" }}>Bank Name</td>
                </tr>
                <tr>
                  <td style={{ backgroundColor: "white" }}>
                    Comments for Recipient / My Initials
                  </td>
                  <td
                    style={{
                      backgroundColor: "white",
                      border: "2px solid red"
                    }}
                  >
                    Your Remit ID
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p>
            <div style={{ margin: "0px", textAlign: "center" }}>
              <PhotoUploadPass
                title1={"PAYMENT RECIEPT PHOTO"}
                title2={"ফিস ট্রান্সফার করে থাকলে তার রসিদ এখানে আপলোড করুন"}
                images={this.state.payPhoto}
                fieldName={"payPhoto"}
                isPayload={false}
                stateChangeHandler={this.stateChangeHandler}
                disabled={false}
              />
            </div>

            <input
              type="file"
              accept="image/*"
              id="uploader"
              onChange={evt => {
                console.log("clicked");
                //console.log("triggering main function");
                event.preventDefault();
                //console.log(evt.target.result);
                if (evt.target.files[0]) {
                  this.idScanTo64(evt.target.files);
                } else {
                  console.log("gotcha");
                }
              }}
              style={{
                visibility: "hidden",
                height: "0px"
              }}
            />
          </p>
          {this.getNextBack("input", "review")}
        </div>
      </div>
    );
  };

  getRow = (heading, value) => {
    return (
      <tr>
        <td>{heading}</td>
        <td>{value}</td>
      </tr>
    );
  };

  render() {
    return (
      <div>
        {this.state.stage === "input" && this.getInputForm()}
        {this.state.stage === "photo" && this.getPhotoInputForm()}
        {this.state.stage === "review" && this.getReview()}
      </div>
    );
  }
}

export default SendRemittance;



// WEBPACK FOOTER //
// ./src/app/components/Screens/landingPage/SendRemittance.jsx